import React, { useState } from 'react';
import { RoundedButton } from '../../../../../elements';
import { vaultStore } from '../../store/VaultStore';
import {
  ModalWrapper,
  ModalContent,
  ModalBody,
  ModalFooter,
  Title,
  Description,
  Message,
} from './ArchiveVaultFileModal.styled';
import { useLocation } from 'react-router-dom';
import { StatusFilterEnum } from '../../enums/StatusFilterEnum';

const ArchiveVaultFileModal = ({ isOpen, onClose, onSubmit, name, fileId, status }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const fullSearch = location.search + location.hash;
  const searchParams = new URLSearchParams(fullSearch.replace("#", "%23"));
  const folderId = decodeURIComponent(searchParams.get('id') || '');
  const customerId = decodeURIComponent(searchParams.get('customerId') || '');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.stopPropagation();
    
    setIsSubmitting(true);
    const success = await vaultStore.archiveDocumentFile(folderId, customerId, fileId, name, "", StatusFilterEnum.ARCHIVED);
    setIsSubmitting(false);
    
    if (success) {
      onSubmit();
    }
  };

  const handleClose = (e) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <ModalWrapper onClick={(e) => e.stopPropagation()}>
      <ModalContent role="dialog" onClick={(e) => e.stopPropagation()}>
        <ModalBody>
          <Title>Archive file</Title>
          <Message>Are you sure you want to archive <strong>{name}</strong>?</Message>
          <Description>You can restore it later from your archive if needed.</Description>
        </ModalBody>
        <ModalFooter>
          <RoundedButton 
            kind="default" 
            outline 
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Cancel
          </RoundedButton>
          <RoundedButton 
            kind="blue" 
            onClick={handleSubmit}
            disabled={isSubmitting}
            data-testid="archive-button"
          >
            {isSubmitting ? 'Archiving...' : 'Archive file'}
          </RoundedButton>
        </ModalFooter>
      </ModalContent>
    </ModalWrapper>
  );
};

export default ArchiveVaultFileModal; 